module.exports = __webpack_public_path__ + "static/media/copiar-icon.96191159.svg";